import { useEffect } from 'react';
import { observeResize, unobserveResize } from '../utils/globalResizeObserver';
export function useResizeObserver(ref, // note: you'll want to memoize this function or the listener will rebind each render
onResize) {
    useEffect(()=>{
        if (!ref.current) {
            return;
        }
        const el = ref.current;
        observeResize(el, onResize);
        return ()=>{
            unobserveResize(el, onResize);
        };
    }, [
        onResize,
        ref
    ]);
}

//# sourceMappingURL=useResizeObserver.js.map